/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLocalFloristIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-local-florist"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 10.18Q12.9 10.18 13.54 9.54Q14.18 8.9 14.18 8Q14.18 7.1 13.54 6.46Q12.9 5.83 12 5.83Q11.1 5.83 10.46 6.46Q9.82 7.1 9.82 8Q9.82 8.9 10.46 9.54Q11.1 10.18 12 10.18ZM12 15.32Q12 15.32 11.46 15.32Q10.93 15.32 10.09 14.75Q9.25 14.18 8.9 13.38Q8.88 13.38 8.78 13.39Q8.68 13.4 8.65 13.4Q7.22 13.4 6.2 12.38Q5.17 11.35 5.17 9.93Q5.17 9.4 5.34 8.91Q5.5 8.43 5.8 8Q5.53 7.58 5.36 7.08Q5.2 6.58 5.2 6.08Q5.2 4.65 6.21 3.63Q7.22 2.6 8.65 2.6Q8.68 2.6 8.78 2.61Q8.88 2.63 8.9 2.63Q9.25 1.82 10.09 1.25Q10.93 0.68 12 0.68Q13.07 0.68 13.91 1.25Q14.75 1.82 15.1 2.63Q15.13 2.63 15.22 2.61Q15.32 2.6 15.35 2.6Q16.77 2.6 17.79 3.63Q18.8 4.65 18.8 6.08Q18.8 6.58 18.65 7.08Q18.5 7.58 18.2 8Q18.48 8.43 18.64 8.93Q18.8 9.43 18.8 9.93Q18.8 11.35 17.79 12.38Q16.77 13.4 15.35 13.4Q15.32 13.4 15.22 13.39Q15.13 13.38 15.1 13.38Q14.75 14.18 13.91 14.75Q13.07 15.32 12 15.32ZM12 22.32Q12 18.95 13.94 16.46Q15.88 13.97 18.95 13.25Q19.45 13.13 19.95 13.18Q20.45 13.22 20.8 13.57Q21.13 13.9 21.16 14.35Q21.2 14.8 21.1 15.22Q20.43 18.38 17.93 20.35Q15.43 22.32 12 22.32ZM12 22.35Q12 18.98 10.06 16.49Q8.13 14 5.05 13.28Q4.55 13.15 4.05 13.19Q3.55 13.22 3.2 13.57Q2.88 13.9 2.84 14.35Q2.8 14.8 2.9 15.22Q3.58 18.38 6.08 20.36Q8.57 22.35 12 22.35Z" fill={color} />
    </svg>
  );
}
